import type { FaireProductEntity } from "../../entity_types/product";

export const p_fqa5abc6j3: FaireProductEntity = {
  token: "p_fqa5abc6j3",
  type: "product",
  name: "20in Long Wavy Clip-In Hair Extensions with Natural Volume",
  brandToken: "b_8p6hzrhexg",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/5c3e0ac7606010f18a6f18844a974c901ceded20f82c5a8ebec396dbd1b5574b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/34083cdde98e9a4fb11acf9cb512e165155f98d0ca571f14b83ce4dc1414641b.jpeg",
    "https://cdn.faire.com/fastly/4693b0d7a490da45e95a53b7ddd7cc82fa5d7d01f6a7783400667563b9ab2776.jpeg",
    "https://cdn.faire.com/fastly/14827d7764041770814b532c814f74010e330c610492c8e29b6510095a1ec20b.jpeg",
    "https://cdn.faire.com/fastly/4f0e325a7375bf2b3395ff9c9289270591996981bbcd89f60a5b7439e23f51af.jpeg",
    "https://cdn.faire.com/fastly/96292f9c96e2673341eccc8daf5ad5cd762bdd9f51e0e3a52ad94ad3421d4258.jpeg",
  ],
  priceDollars: 16.62,
  description:
    "These long wavy clip-in hair extensions add instant length, fullness, and dimension with soft, natural-looking waves that blend seamlessly into your own hair. The lightweight wefts attach easily with secure clips, offering comfortable all-day wear without slipping. Designed with realistic, silky fibers, the extensions provide smooth movement and a polished finish. Perfect for enhancing everyday styles or creating a glamorous, voluminous look with minimal effort.",
  tags: [],
  msrpDollars: 33.23,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:38.157Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
